import Vue from 'vue'

// axios
import axios from 'axios'
import { apiListsUrl, tenant } from '@/constants/config'
import { attachAuthRequestInterceptor, attachAuthResponseInterceptor } from '@/libs/authToken'

const axiosIns = axios.create({
  baseURL: apiListsUrl,
  headers: {
    'X-tenant': tenant,
  },
})

attachAuthRequestInterceptor(axiosIns)
attachAuthResponseInterceptor(axiosIns)

Vue.prototype.$http = axiosIns

export default axiosIns
